import { Dashboard, MeetingRoom, Note, Person } from "@mui/icons-material";
import React from "react";
import MainContainer from "../components/container";
import PersistentDrawer, { DrawnerElement, DrawnerLink } from "../components/persistenDrawer";


// Vista principal del panel de inicio
const Home: React.FC = () => {
    return (
        <MainContainer name="Principal">
            <UsuariosPanel />
        </MainContainer>
    )
};

// Panel interno del inicio con enlaces a los módulos principales
const UsuariosPanel: React.FC = () => {
    const elements: DrawnerElement[] = [
        { title: "Administrador", label: "Administrador", view: <div></div> }, // Vista base del administrador
    ];
    const links: DrawnerLink[] = [
        { label: "Comunicaciones", to:"/comunicaciones", icon: <Note /> }, // Enlace al módulo de comunicaciones
        { label: "Magistrados", to:"/magistrados", icon: <Dashboard /> }, // Enlace al módulo de magistrados
        { label: "Usuarios", to:"/usuarios", icon: <Person /> }, // Enlace al módulo de usuarios
        { label: "Reuniones", to:"/reuniones", icon: <MeetingRoom /> }, // Enlace al módulo de reuniones
    ];
    const [selected, setselected] = React.useState<DrawnerElement>(elements[0]); // Elemento seleccionado por defecto
    function onSavedPost(){
        setselected(elements[1]); // Cambia el elemento seleccionado
    };
    return(
        <PersistentDrawer selected={selected} setselected={setselected} elements={elements} links={links}></PersistentDrawer>
    )
}

export default Home;